import { Button, Paper } from "@mui/material";
import { TextFieldWrapper } from "components/Wrappers/FormComponentsWrappers/TextFieldWrapper";
import { FormModal } from "components/ModalForm/ModalForForm";
import { STATUS_CODES } from "constants/responses/statusCodes";
import { useGlobalContext } from "context/GlobalContext";
import { useEffect, useState } from "react";
import { useUsersContext } from "../context";
import { updateUserApi } from "API/apis/admin/users/updateUserApi";
import { PageTitle } from "components/PageMeta/PageTitle";
import { pageName } from "constants/pageNames";
import { FormControlWrapper } from "components/Wrappers/FormComponentsWrappers/FormControlWrapper";
import { DeptSelector } from "components/SearchSelect/DeptSelector";
import { SearchUsers } from "components/SearchSelect/SearchUsers";

const initialUserDetail = {
  name: "",
  dept: "",
  subDept: "",
  userId: "",
};
export const UpdateUserFormModal = ({
  openModal,
  setOpenModal,
  currentFormData,
}) => {
  const { setError, setSuccess, setIsLoading } = useGlobalContext();
  const { isReloadRequired, setIsReloadRequired } = useUsersContext();
  const [formData, setFormData] = useState({
    ...currentFormData,
  });
  const [selectedMgr, setSelectedMgr] = useState(initialUserDetail);

  useEffect(() => {
    setFormData({ ...currentFormData });
  }, [currentFormData]);

  const handleChange = (event) => {
    setFormData({
      ...formData,
      [event.target.name]: event.target.value,
    });
  };
  const handleSelectDept = (newValue) => {
    setFormData({
      ...formData,
      deptId: newValue?.id || 0,
    });
  };

  const handleUpdateUserSubmit = async (e) => {
    e.preventDefault();
    try {
      setFormData({ ...formData });
      setIsLoading(true);
      setOpenModal(false);
      const { data, status } = await updateUserApi({
        ...formData,
        mgrUserId: selectedMgr?.userId || "",
      });
      if (status !== STATUS_CODES.SUCCESS) {
        throw new Error(data.message);
      }
      setIsReloadRequired(!isReloadRequired);
      setSuccess(data?.message);
      setFormData(formData);
    } catch (error) {
      setError(error.message);
      setOpenModal(true);
    }
  };
  return (
    <>
      <FormModal
        open={openModal}
        onClose={() => setOpenModal(false)}
        aria-labelledby="parent-modal-title"
        aria-describedby="parent-modal-description"
        closeAfterTransition
      >
        <Paper className="formModal-class">
          <PageTitle pageName={pageName.admin.users.updateUser} />
          <form onSubmit={handleUpdateUserSubmit}>
            <TextFieldWrapper
              id="username"
              name="username"
              label="Username"
              variant="outlined"
              value={formData.username}
              fullWidth
              disabled
              onChange={handleChange}
            />
            <TextFieldWrapper
              id="email"
              name="email"
              label="Email"
              variant="outlined"
              value={formData.email}
              fullWidth
              required
              onChange={handleChange}
            />
            <TextFieldWrapper
              id="firstName"
              name="firstName"
              label="First Name"
              variant="outlined"
              value={formData.firstName}
              fullWidth
              required
              onChange={handleChange}
            />
            <TextFieldWrapper
              id="lastName"
              name="lastName"
              label="Last Name"
              variant="outlined"
              value={formData.lastName}
              fullWidth
              required
              onChange={handleChange}
            />
            <TextFieldWrapper
              id="phoneNumber"
              name="phoneNumber"
              label="Phone Number"
              variant="outlined"
              value={formData.phoneNumber}
              fullWidth
              required
              onChange={handleChange}
            />
            <FormControlWrapper fullWidth>
              <DeptSelector
                handleDeptSelection={handleSelectDept}
                label="Department"
                selectedDept={formData.deptId}
              />
              <TextFieldWrapper
                label="Current Reporting Manager"
                variant="outlined"
                value={formData.mgrName}
                fullWidth
                disabled
              />
              <FormControlWrapper fullWidth>
                <SearchUsers
                  label="Reporting Manager"
                  handleUserSelection={setSelectedMgr}
                  selectedUser={selectedMgr}
                />
              </FormControlWrapper>
            </FormControlWrapper>
            <Button variant="contained" type="submit" fullWidth>
              Update
            </Button>
          </form>
        </Paper>
      </FormModal>
    </>
  );
};
